<template>
    <div>

        <transition name="fade">
            <div v-if="fetchState.pending">
                <div>
                    <div class="search-panel__result-header">
                        <span class="skeleton-box skeleton-box--margin-bottom skeleton-box--title" style="width: 50%;"></span>
                    </div>

                    <h4><span class="skeleton-box skeleton-box--margin-bottom skeleton-box--title m-b-xs-5" style="width: 20%;"></span></h4>

                    <div class="tiles tiles--grid-4">
                        <div class="tile-wrapper" v-for='index in 12' :key='index'>
                            <a href="#" class="tile tile--no-hover">
                                <div class="tile__top">
                                    <div class="tile__top-title">
                                        <span class="skeleton-box" style="width: 75px;"></span>
                                    </div>
                                </div>
                                <div class="placeholder placeholder--border-radius-small placeholder--tall">

                                </div>
                                <div class="tile__bottom">
                                    <span class="skeleton-box skeleton-box--margin-bottom" style="width: 100%;"></span>
                                </div>
                                <span class="skeleton-box" style="width: 50%;"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <slot v-else></slot>
        </transition>
    </div>
</template>
<script>
/**
 * Place elements inside this component if you want them not visible when loading data
 */
import {useStore} from 'vuex'
import {computed} from 'vue'

export default {
    name: "CatchPending",
    setup() {
        const store = useStore()
        const fetchState = computed(() => store.state.fetchState)
        return {
            fetchState,
        }
    }
}
</script>